<div class="progress-bar" *ngIf="items?.length > 0">
    <div class="pb-done" [ngStyle]="getProgressDoneStyle()"></div>
    <div class="pb-attention-done" [ngStyle]="getProgressAttentionDoneStyle()"></div>
    <div class="pb-attention-todo" [ngStyle]="getProgressAttentionTodoStyle()"></div>
</div>
